<template>
	<div class="topbar">
		<!-- <button class="btn switch" :class="{'active': button.state === 'active' }" v-for="button in buttons" :key="button.id" @click="toggleButton(button.id)">{{button.caption[button.state]}}</button> -->
		<button class="btn refresh" @click="fetchData"><i class="fa fa-2x fa-refresh" :class="{'fa-spin fa-fw': busy}" aria-hidden="true"></i></button>
		<button class="btn switch" :class="{'active': button.active }" v-for="button in buttons" :key="button.id" @click="toggleButton(button.id)">{{button.caption}}</button>
		<button class="btn logout" @click="logout"><i class="fa fa-2x fa-sign-out" aria-hidden="true"></i></button>
	</div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'

export default {
	computed: {
		...mapGetters({
			'buttons': 'displayButtons',
			'busy' : 'isBusy'
		})
	},

	methods: {
		...mapActions([
			'toggleButton',
			'logout',
			'fetchData'
		])
	}
}
</script>

<style>
.topbar {
	position: fixed;
	height: 50px;
	
	top: 0;
	left: 0;
	right: 0;
	background-color: #2c3e50;
	z-index: 200;

	display: flex;
	justify-content: stretch;
}

.topbar BUTTON {
	margin:5px;
	margin-right: 0;

	border: 2px solid #69808d;
	border-radius: 10px;
	background-color: inherit;

	/* color: #FFF; */
	color: #F2F2F2;

	outline: 0;
	
}

.topbar BUTTON.active {
	background-color: #69808d;
}

.topbar BUTTON:last-of-type {
	margin-right: 5px;
}


.topbar .refresh {
	width: 50vw;
}


.topbar .switch {
	flex-grow:1;
	flex-basis: 100%;
	font-size: 110%;
}

</style>
